import type { JSX } from 'react';
import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { CountrySelect } from '@/components/molecules/CountrySelect';
import type { EducationFormData } from './EducationFormFields';

interface LocationFieldsProps {
  register: UseFormRegister<EducationFormData>;
  errors: FieldErrors<EducationFormData>;
  country: string;
  onCountryChange: (v: string) => void;
}

export function LocationFields({
  register,
  errors,
  country,
  onCountryChange,
}: LocationFieldsProps): JSX.Element {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="city">
          City <span className="text-destructive">*</span>
        </Label>
        <Input
          id="city"
          placeholder="Belgrade"
          {...register('city', { required: 'City is required' })}
        />
        {errors.city && <p className="text-sm text-destructive">{errors.city.message}</p>}
      </div>
      <div className="space-y-2">
        <Label htmlFor="country">
          Country <span className="text-destructive">*</span>
        </Label>
        <CountrySelect value={country || null} onValueChange={onCountryChange} />
        {errors.country && <p className="text-sm text-destructive">{errors.country.message}</p>}
      </div>
    </div>
  );
}
